import __request__ from 'routing/request';
interface MetadataRequest {
    readonly url: string;
}
interface CertInfoRequest {
    readonly certificate: string;
}
interface DefaultAttributeMapping {
    readonly full_name: string[];
    readonly user_name: string[];
    readonly last_name: string[];
    readonly groups: string[];
    readonly first_name: string[];
    readonly email: string[];
}
interface SAMLCertInfo {
    readonly subject: string;
    readonly valid_to: string;
    readonly certificate: string;
    readonly valid_from: string;
    readonly sha1_fingerprint: string;
    readonly sha256_fingerprint: string;
    readonly issuer: string;
}
interface BackendDetails {
    readonly idp_certs: {
        readonly [_key: string]: SAMLCertInfo;
    };
    readonly id: string;
    readonly sp_certs: {
        readonly [_key: string]: SAMLCertInfo;
    };
}
interface SPCredentialResponse {
    readonly certificate: string;
    readonly private_key: string;
}
interface SAMLIdpMetadata {
    readonly certificates: string[];
    readonly logout_service_redirect_binding_url: string;
    readonly logout_service_post_binding_url: string;
    readonly sso_service_redirect_binding_url: string;
    readonly entity_id: string;
    readonly sso_service_post_binding_url: string;
    readonly url: string;
}
/**
 * Retrieve certificate info
 */
export function getCertificateInfo(JSONBody: CertInfoRequest): Promise<SAMLCertInfo> {
    return __request__('POST', '/plugins/org.graylog.plugins.security/saml/config/certinfo', JSONBody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieve backend details
 */
export function getBackendDetails(backendId: string): Promise<BackendDetails> {
    return __request__('GET', `/plugins/org.graylog.plugins.security/saml/config/details/${backendId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieve the IdP default attribute mapping
 */
export function getIdpDefaultAttributeMapping(): Promise<DefaultAttributeMapping> {
    return __request__('GET', '/plugins/org.graylog.plugins.security/saml/config/idp/default-attribute-mapping', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieve IdP metadata URL
 */
export function getIdpMetadata(JSONbody: MetadataRequest): Promise<SAMLIdpMetadata> {
    return __request__('POST', '/plugins/org.graylog.plugins.security/saml/config/idp/metadata', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Generate SP credentials
 */
export function generateSpCredentials(): Promise<SPCredentialResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.security/saml/config/sp/credentials', null, {}, {
        'Accept': ['application/json']
    });
}
